module.exports = __webpack_public_path__ + "img/3.1.e783cd4b.png";